import { FormattedMessage } from 'react-intl';
import React from 'react';
import CustomSelect from '../../components/customFields/customSelect';
import { useStartDepots } from './apiHooks';
import Loader from '../../components/loader';

const AdminRoutePlanStartDepot = ({ setStartDepot, startDepot }) => {
  const { startDepots, isLoading: startDepotsLoading } = useStartDepots();

  const startDepotOptions = startDepots
    ? startDepots.map((depot) => ({
        value: depot,
        label: `#${depot.id} - ${depot.name}`,
      }))
    : [];

  if (startDepotsLoading) {
    return <Loader show={true} />;
  }

  const selectedStartDepot = startDepots.find((depot) => depot.id === startDepot?.id);

  return (
    <div>
      <h3>
        <FormattedMessage id={'admin.route.planning.create.start.depot.header'} />
      </h3>
      <div className="m-b-2">
        <CustomSelect
          onChange={(depot) => setStartDepot(depot)}
          schema={{
            options: startDepotOptions,
            showClearOption: true,
          }}
          formData={selectedStartDepot}
        />
      </div>
      <div className="d-none">
        <button className="btn btn-small btn-default m-r-2">
          <FormattedMessage id={'admin.route.planning.create.start.depot.create.new.temporary'} />
        </button>
      </div>
    </div>
  );
};

export default AdminRoutePlanStartDepot;
